// ViewPortMeta needs to be included in the head of every page to ensure that the page is responsive on mobile devices.
// It can't be used in _document.tsx because Next yells and errors.
export function ViewportMeta() {
  return <meta name="viewport" content="width=device-width, initial-scale=1" />;
}
